import type { MutationHookOptions } from '@apollo/client'
import { TrainingsCategoriesDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateTrainingsCategoryDocument,
  CreateTrainingsCategoryMutation,
  CreateTrainingsCategoryMutationVariables,
  TrainingsCategoriesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingsCategoryMutation,
  CreateTrainingsCategoryMutationVariables
>

export const useCreateCategory = (options?: Options) => {
  const [createTraining, { loading }] = useMutation(CreateTrainingsCategoryDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsCategory,
  })

  return {
    loading,
    create(variables: CreateTrainingsCategoryMutationVariables) {
      return createTraining({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingsCategoriesDataTableDocument, TrainingsCategoriesDocument],
      })
    },
  }
}
